// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_components_customer-search_customer-search_module_ts":"0d9097d9dadc4266","src_app_components_customer-rule_customer-rule_module_ts":"cde34deb0086f5d3","src_app_components_customer-search_customer-search-routing_module_ts":"3d532380ccaf1aec"}[chunkId] + ".js";
};